import React from "react"
import { Container, font, SimpleGrid, Text, SimpleGridProps } from "@carrotfertility/carotene"

type ReimbursementDescriptionListProps = React.PropsWithChildren<Pick<SimpleGridProps, "columns">>

interface ReimbursementDescriptionGroupProps {
  title: React.ReactNode
  value: React.ReactNode
}

export function ReimbursementDescriptionList({ children, columns = [1, null, 4] }: ReimbursementDescriptionListProps) {
  return (
    <dl>
      <SimpleGrid spacing="tiny" columns={columns}>
        {children}
      </SimpleGrid>
    </dl>
  )
}

export function ReimbursementDescriptionGroup({ title, value }: ReimbursementDescriptionGroupProps) {
  return (
    <Container sx={{ alignSelf: "end" }}>
      <dt>
        <Text
          sx={{ fontFamily: font.family.gotham, letterSpacing: "0.07rem", textTransform: "uppercase" }}
          size="11px"
          color="black80"
          as="span"
          weight="semibold"
        >
          {title}
        </Text>
      </dt>
      <dd>
        <Text sx={{ fontFamily: font.family.gotham }} weight="semibold" as="span" color="black">
          {value}
        </Text>
      </dd>
    </Container>
  )
}
